<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="multi-select-container">
  @if (label) {
    <label
      class="xrx-multi-select-header-label"
      [ngClass]="leftAlignText ? 'align-left' : 'xrx-section-header'"
      [xdaTranslate]="label"></label>
  }
  <div
    class="list-group xrx-list-group xrx-multi-select-list"
    [ngClass]="{ 'multi-select-scrollbar': hasScrollbar }">
    @for (item of list; track item) {
      <div
        (click)="rowClicked(item)"
        #toLanguageItem
        class="xrx-multi-select-item"
        [ngClass]="{
          'form-control': isBordered,
          'align-left': leftAlignText,
          'invalid-row': item.matchesToLanguage,
        }">
        <div class="list-group-embeded-control">
          <div class="embeded-control-blanket">&nbsp;</div>
          <xrx-checkbox
            class="tos-checkbox"
            [(checkBoxValue)]="item.checked!"
            [name]="item.value.toString() || ''"
            (toggle)="onChecked($event, item)"
            stop-event-propagation></xrx-checkbox>
        </div>
        <span class="info" [xdaTranslate]="getPropertyString(item)"></span>
      </div>
    }
  </div>
</div>
